import {GET_PAYMENT_CARDS} from '../actions/types';

export const paymentReducer = (state = {} , action) => {
    switch(action.type) {
        case GET_PAYMENT_CARDS:
            return {...state, paymentCards: action.payload} || {};
        default:
            return state;
    }
}